import {createFileRoute} from '@tanstack/react-router';
import {ThemePage} from '../../../../features/settings/pages/ThemePage';

export const Route = createFileRoute('/_protected/home/service/theme')({
  component: ThemePage,
  staticData: {crumbKey: 'navigation.theme'},
});
